export default __webpack_public_path__ + "static/media/small-hand.4c5c79d0.png";